module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_pp3_3016.58233ad3.png";